import React, { useContext } from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import { DialogTitle, IconButton, DialogActions } from "@mui/material"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import { useDispatch, useSelector } from "react-redux"
import { yupResolver } from "@hookform/resolvers/yup"
import { FormProvider, useForm } from "react-hook-form"
import * as yup from "yup"
import TokenContext from "../../context/TokenContext"
import { UserAuth } from "../../context/AuthContext"
import CustomSelect from "../CustomSelect"
import CustomSearchSelect from "../CustomSearchSelect"
import CustomTextField from "../CustomTextField"
import CustomDateField from "../CustomDateField"

const ModalTituloPropiedad = ({ open, handleClose, onSubmit }) => {
    const token = useContext(TokenContext)
    const dispatch = useDispatch()
    const { empleado } = UserAuth()

    const defaultValues = {
        new_name: '',
        new_titular: '',
        new_fechasolicitud: '',
        new_fechaotorgamiento: '',
    }

    const validacionSchema = yup.object().shape({
        new_name: yup.string().required("Required"),
        new_titular: yup.string().required("Required"),
        new_fechasolicitud: yup.string().required("Required"),
    })

    const methods = useForm({
        shouldUnregister: false,
        defaultValues,
        resolver: yupResolver(validacionSchema),
        mode: "onChange",
        shouldFocusError: true,
    })

    const { handleSubmit, reset } = methods

    const submitDatos = (datos) => {
        onSubmit(datos)
    }

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Crear Título de Propiedad Intelectual</DialogTitle>
            <FormProvider {...methods}>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_name"
                                label="Tipo, Desarrollo o Producto"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica el Tipo, Desarrollo o Producto."
                                className="custom-helper"
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_titular"
                                label="Titular"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica el titular."
                                className="custom-helper"
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ mt: 1 }}>
                            <CustomDateField
                                name="new_fechasolicitud"
                                label="Fecha solicitud:"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica la fecha de solicitud"
                                req={true}
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ mt: 1 }}>
                            <CustomDateField
                                name="new_fechaotorgamiento"
                                label="Fecha otorgamiento:"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica la fecha de otorgamiento"
                                
                                className="custom-helper"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose()} color="secondary" >
                        <Typography sx={{ fontWeight: 'bold' }}>Cerrar</Typography>
                    </Button>
                    <Button
                        type="submit"
                        variant="text"
                        color="secondary"
                        onClick={handleSubmit(submitDatos)}
                    >
                        <Typography sx={{ fontWeight: 'bold' }}>Crear</Typography>
                    </Button>
                </DialogActions>
            </FormProvider>
        </Dialog>
    )
}

export default ModalTituloPropiedad